// @flow

const { DateTimeFormat } = global.Intl;

const LOCALE_DEFAULT = 'da-DK';
const LOCALE_FALLBACK = 'en-GB';

export const date = {
  DateTimeFormat,
  locale: undefined,
  format: undefined
};

export const datetime = {
  DateTimeFormat,
  locale: undefined,
  format: undefined
};

export const time = {
  DateTimeFormat,
  locale: undefined,
  format: undefined
};

function init(target, options) {
  try {
    const dtf = new DateTimeFormat([LOCALE_DEFAULT, LOCALE_FALLBACK], options);
    target.format = dtf.format;
    target.locale = dtf.resolvedOptions().locale;
  } catch (e) {
    if (__DEV__) {
      console.error(e);
    }
    target.format = date => {
      const dateStr = date.toISOString();
      return dateStr
        .substr(0, 10)
        .split('-')
        .reverse()
        .join('/');
    };
    target.locale = 'da-DK';
  }
}

init(date, {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'Europe/Copenhagen'
});

init(datetime, {
  hour: '2-digit',
  minute: '2-digit',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: 'Europe/Copenhagen'
});

init(time, {
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Europe/Copenhagen'
});
